import O1HD from "../../../../engines/gameEngine";
import data_control from "../../../../engines/libs/data_control";
import NormalGameManager from "../../manager/NormalGameManager";

const { ccclass, property } = cc._decorator;

@ccclass
export default class StockPrefab extends cc.Component {
    @property({ type: cc.Node, displayName: "对话节点" })
    dialogNode: cc.Node = null;
    @property({ type: cc.Label, displayName: "对话文本" })
    dialogLable: cc.Label = null;
    @property({ type: cc.Node, displayName: "中心节点" })
    centerNode: cc.Node = null;

    @property({ type: cc.Prefab, displayName: "股票买入预制体" })
    stockPutInPrefab: cc.Prefab = null;

    @property({ type: cc.Node, displayName: "UI节点" })
    UINode: cc.Node = null;

    @property({ type: cc.Prefab, displayName: "特殊事件" })
    stockEventPrefab: cc.Prefab = null;

    @property({ type: sp.Skeleton, displayName: "人物动画" })
    peopleAnima: sp.Skeleton = null;

    start() {
        if (NormalGameManager._instance.getGameData().todayDate != data_control.getCurrDateDayString()) {
            let stockEvent = cc.instantiate(this.stockEventPrefab);
            this.node.addChild(stockEvent);
        }
        // this.centerNode.scale = 0
        // cc.tween(this.centerNode).to(.5, { scale: 1 }, { easing: cc.easing.backInOut }).call(() => {
        // }).start();
        this.peopleTalk()
    }

    peopleTalk() {
        this.peopleAnima.setAnimation(0, "Idle", false);
        this.peopleAnima.setCompleteListener(() => {
            this.dialogNode.active = true;
            this.dialogLable.string = "我是基金售卖员，请问是需要买基金吗？";
            this.peopleAnima.setAnimation(0, "Talk", true);
            this.peopleAnima.setCompleteListener(null);
            this.scheduleOnce(() => {
                this.peopleTalk()
                this.dialogNode.active = false;
            }, 3)
        })
    }

    onCloseBtn() {
        // cc.tween(this.centerNode).to(.5, { scale: 0 }, { easing: cc.easing.backIn }).call(() => {

        // }).start();
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.node.destroy();
    }

    onBuyStockBtn() {
        let stockPutIn = cc.instantiate(this.stockPutInPrefab);
        this.UINode.addChild(stockPutIn);
    }

    protected onDisable(): void {
        O1HD.emit("normalMode.onBackNormal","FoodStreet");
    }

}
